var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetsIconsForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00024 7C4.00024 5.114 4.00024 4.172 4.58624 3.586C5.17224 3 6.11424 3 8.00024 3H16.0002C17.8862 3 18.8282 3 19.4142 3.586C20.0002 4.172 20.0002 5.114 20.0002 7V15C20.0002 17.828 20.0002 19.243 19.1212 20.121C18.2432 21 16.8282 21 14.0002 21H10.0002C7.17224 21 5.75724 21 4.87924 20.121C4.00024 19.243 4.00024 17.828 4.00024 15V7Z",
    stroke: "#162D4F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 18V21M9.00024 18V21M9.00024 8.00003H15.0002M9.00024 12H15.0002",
    stroke: "#162D4F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsIconsForm);
export default __webpack_public_path__ + "static/media/lets-icons_form.d9ce8c6719eb5f096e02a03599729740.svg";
export { ForwardRef as ReactComponent };